module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header navbar navbar-default navbar-fixed-top",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "src": _vm.logo
    }
  }), _vm._v(" " + _vm._s(_vm.title))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "dropdown navbar-user"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    attrs: {
      "src": this.picture,
      "alt": "avatar"
    },
    on: {
      "error": function($event) {
        this.src = '~@/assets/img/avatar-default.svg'
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }), _vm._v(" "), _c('b', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu animated fadeInLeft"
  }, [_c('li', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.handleLogout
    }
  }, [_vm._v("Log Out")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-click": "sidebar-toggled"
    }
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e8b9283","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/global/components/layout/Header.vue
// module id = 2211
// module chunks = 1